// Library Methods
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import Alert from "src/components/shared/alerts/Alert/Alert";
import RAPDChart from "./RAPDChart/RAPDChart";
import RAPDOverview from "./RAPDOverview/RAPDOverview";
import RAPDPupilDiameters from "./RAPDPupilDiameters/RAPDPupilDiameters";

// Contexts
import { ReportContext } from "src/contexts/reports/ReportContext";
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

// Constants
import { examCardEnums } from "src/constants/enums";

// Utils
import { isTerminatedExamReport } from "src/utils/exams/examReportsHelper";

const RAPDGraph = () => {
  const { t } = useTranslation();

  const { exam } = useContext(ReportContext);
  const { examReport } = useContext(ReportSectionContext);

  const isTerminated = useMemo(
    () =>
      isTerminatedExamReport({
        exam,
        examReport,
        sectionName: examCardEnums.RAPD.sectionName,
      }),
    [exam, examReport]
  );

  const rapdResults = useMemo(
    () => examReport?.postProcessing?.rapdResults,
    [examReport]
  );

  const anisocoriaResults = useMemo(
    () => examReport?.postProcessing?.anisocoriaResults,
    [examReport]
  );

  return (
    <Grid container gap="20px">
      {isTerminated && (
        <Alert
          variant="error"
          alertContent={t("Terminated Exam")}
          props={{ width: "100%" }}
        />
      )}

      {rapdResults && <RAPDOverview rapdResults={rapdResults} />}
      <Grid item xs={12}>
        <RAPDChart
          chartData={examReport?.postProcessing}
          testDuration={examReport?.timing?.elapsed}
        />
      </Grid>
      {anisocoriaResults && (
        <RAPDPupilDiameters anisocoriaResults={anisocoriaResults} />
      )}
    </Grid>
  );
};

export default RAPDGraph;
